import { sendTrackingEvent } from "./base-tracker"

function getPageKey() {
  return (window.slideshare_object && window.slideshare_object.page_key) || null
}

function getSlideshowId() {
  return (
    (window.slideshare_object && window.slideshare_object.slideshow && window.slideshare_object.slideshow.id) || "-1"
  )
}

if (window.feature_flags.frontendPageViewEvents) {
  sendTrackingEvent("frontend_page_view_event_stream", {
    path: window.location.pathname,
    slideshow_id: getSlideshowId(),
    page_key: getPageKey(),
  })
}
